import saas from '@/utils/saas'
// import request from '@/utils/request'
import encrypt_str from '@/utils/crypto'
import Common from '@/utils/saas/common' // 工具类

// export function defaultImg(param) {
//   const service = saas.ServiceName.DICT_API
//   const api = 'GET_RANDOMCODE'
//   const data = saas.data(service, api, param)
//   return request({
//     url: saas.Constant.GATEWAY_URL + '/' + service + '/api/' + api,
//     method: 'post',
//     data
//   })
// }
export function defaultImg(data) {
  return Common.createRequest(saas.ServiceName.DICT_API, 'GET_RANDOMCODE', data)
}

// export function checkImg(param) {
//   const service = saas.ServiceName.DICT_API
//   const api = 'CHECK_RANDOMCODE'
//   const data = saas.data(service, api, param)
//   return request({
//     url: saas.Constant.GATEWAY_URL + '/' + service + '/api/' + api,
//     method: 'post',
//     data
//   })
// }
export function checkImg(data) {
  return Common.createRequest(saas.ServiceName.DICT_API, 'CHECK_RANDOMCODE', data)
}

// export function addLogin(param) {
//   const service = saas.ServiceName.CUSTOMER_API
//   const api = 'customer_login'
//   const data = saas.data(service, api, param)
//   return request({
//     url: saas.Constant.GATEWAY_URL + '/' + service + '/api/' + api,
//     method: 'post',
//     data
//   })
// }
export function addLogin(data) {
  return Common.createRequest(saas.ServiceName.CUSTOMER_API, 'customer_login', data)
}

// export function checkSms(param) {
//   const service = saas.ServiceName.DICT_API
//   const api = 'VERIFY_SMS'
//   const data = saas.data(service, api, param)
//   return request({
//     url: saas.Constant.GATEWAY_URL + '/' + service + '/api/' + api,
//     method: 'post',
//     data
//   })
// }
export function checkSms(data) {
  return Common.createRequest(saas.ServiceName.DICT_API, 'VERIFY_SMS', data)
}

// export function getSms(param) {
//   const service = saas.ServiceName.DICT_API
//   const api = 'SEND_SMS'
//   const data = saas.data(service, api, param)
//   return request({
//     url: saas.Constant.GATEWAY_URL + '/' + service + '/api/' + api,
//     method: 'post',
//     data
//   })
// }
export function getSms(data) {
  return Common.createRequest(saas.ServiceName.DICT_API, 'SEND_SMS', data)
}

// export function getInfo(param) {
//   const service = saas.ServiceName.CUSTOMER_API
//   const api = 'INFO'
//   const data = saas.data(service, api, param)
//   return request({
//     url: saas.Constant.GATEWAY_URL + '/' + service + '/api/' + api,
//     method: 'post',
//     data
//     // params: { token }
//   })
// }
export function getInfo(data) {
  return Common.createRequest(saas.ServiceName.CUSTOMER_API, 'INFO', data)
}

// export function logout(param) {
//   const service = saas.ServiceName.CUSTOMER_API
//   const api = 'customer_logout'
//   const data = saas.data(service, api, param)
//   data.xUserAction = '退出登录'
//   return request({
//     url: saas.Constant.GATEWAY_URL + '/' + service + '/api/' + api,
//     method: 'post',
//     data
//   })
// }
export function logout(data) {
  return Common.createRequest(saas.ServiceName.CUSTOMER_API, 'customer_logout', data)
}

// export function phoneLogin(param) {
//   const service = saas.ServiceName.CUSTOMER_API
//   const api = 'customer_login'
//   const data = saas.data(service, api, param)
//   data.xUserAction = '登录'
//   return request({
//     url: saas.Constant.GATEWAY_URL + '/' + service + '/api/' + api,
//     method: 'post',
//     data
//   })
// }
export function phoneLogin(data) {
  return Common.createRequest(saas.ServiceName.CUSTOMER_API, 'customer_login', data)
}

// export function phoneRegister(param) {
//   const service = saas.ServiceName.USER_API
//   const api = 'PHONE_REGISTER'
//   const data = saas.data(service, api, param)
//   return request({
//     url: saas.Constant.GATEWAY_URL + '/' + service + '/api/' + api,
//     method: 'post',
//     data
//   })
// }
export function phoneRegister(data) {
  return Common.createRequest(saas.ServiceName.USER_API, 'PHONE_REGISTER', data)
}

// export function phoneResetPassword(param) {
//   const service = saas.ServiceName.USER_API
//   const api = 'PHONE_RESET_PASSWORD'
//   const data = saas.data(service, api, param)
//   return request({
//     url: saas.Constant.GATEWAY_URL + '/' + service + '/api/' + api,
//     method: 'post',
//     data
//   })
// }
export function phoneResetPassword(data) {
  return Common.createRequest(saas.ServiceName.USER_API, 'PHONE_RESET_PASSWORD', data)
}

// export function phoneSmsCodeLogin(param) {
//   const service = saas.ServiceName.USER_API
//   const api = 'PHONE_SMS_CODE_LOGIN'
//   const data = saas.data(service, api, param)
//   return request({
//     url: saas.Constant.GATEWAY_URL + '/' + service + '/api/' + api,
//     method: 'post',
//     data
//   })
// }
export function phoneSmsCodeLogin(data) {
  return Common.createRequest(saas.ServiceName.USER_API, 'PHONE_SMS_CODE_LOGIN', data)
}

// export function phoneSmsCodeRegister(param) {
//   const service = saas.ServiceName.USER_API
//   const api = 'PHONE_SMS_CODE_REGISTER'
//   const data = saas.data(service, api, param)
//   return request({
//     url: saas.Constant.GATEWAY_URL + '/' + service + '/api/' + api,
//     method: 'post',
//     data
//   })
// }
export function phoneSmsCodeRegister(data) {
  return Common.createRequest(saas.ServiceName.USER_API, 'PHONE_SMS_CODE_REGISTER', data)
}

// export function register(param) {
//   const service = saas.ServiceName.CUSTOMER_API
//   const api = 'customer_register'
//   const data = saas.data(service, api, param)
//   return request({
//     url: saas.Constant.GATEWAY_URL + '/' + service + '/api/' + api,
//     method: 'post',
//     data
//   })
// }
export function register(data) {
  return Common.createRequest(saas.ServiceName.CUSTOMER_API, 'customer_register', data)
}

// export function getCustomer(param) {
//   param.phoneOrLoginName = encrypt_str(param.phoneOrLoginName)
//   const service = 'customer-api'
//   const api = 'customer_search_by_phone_or_login_name_web'
//   const data = saas.data(service, api, param)
//   return request({
//     url: saas.Constant.GATEWAY_URL + '/' + service + '/api/' + api,
//     method: 'post',
//     data
//   })
// }
export function getCustomer(data) {
  data.phoneOrLoginName = encrypt_str(data.phoneOrLoginName)
  return Common.createRequest('customer-api', 'customer_search_by_phone_or_login_name_web', data)
}

// 查询用户信息接口
// export function customerInfoSearch(param) {
//   param.accountNo = encrypt_str(param.accountNo)
//   const service = saas.ServiceName.CUSTOMER_API
//   const api = 'customer_info_search_for_web'
//   const data = saas.data(service, api, param)
//   return request({
//     url: saas.Constant.GATEWAY_URL + '/' + service + '/api/' + api,
//     method: 'post',
//     data
//   })
// }
export function customerInfoSearch(data) {
  data.accountNo = encrypt_str(data.accountNo)
  return Common.createRequest(saas.ServiceName.CUSTOMER_API, 'customer_info_search_for_web', data)
}
